import request from '@/utils/request'

// forum页面左边的模块

// 1.是固走的链接 后台要给个入口可以编辑图文信息 
export function wenzhangLie(data) {
  return request({
    url: '/article/page',
    method: 'post',
	  data: data
  })
}
// 1详情
export function wenzhangxq(id) {
  return request({
    url: `/article/info/${id}`,
    method: 'get'
  })
}
// 2
export function tieziLie(data) {
  return request({
	  url: '/invitation/page',
    method: 'post',
	data: data
  })
}

// 3
export function ziyuanLie(data) {
  return request({
    url: '/resourceRecommend/page',
    method: 'post',
	data: data
  })
}

// My picks
export function myPicks(data) {
  return request({
    url: `/invitation/pick/page?pageNum=${data.pageNum}&size=${data.pageSize}`,
    method: 'get'
  })
}
//官方帖子
export function guanfantie(data) {
  return request({
	  url: '/invitation/officialPage',
    method: 'post',
	data: data
  })
}
//plus展示帖子
export function plustie(data) {
  return request({
	  url: '/invitation/plusPage',
    method: 'post',
	data: data
  })
}
